<script>
  import { useLocation } from '../svelte-navigator';
  import { Grid, Loading, AnchorCell, Notification } from '../components';
  import { queryResults } from '../stores.js';
  import { testQuery } from '../api.js';

  const location = useLocation();

  export let id = null;
  export let componentId;

  const columns = [
    { name: "Name", value: x => x.name },
    { name: "URL", value: x => x.url, component: AnchorCell, props: x => ({ href: x.url }) }
  ];

  async function loadDocs() {
    let componentQuery;
    if ($location.state.componentQuery) {
      componentQuery = $location.state.componentQuery;
    } else {
      componentQuery = await getQuery(id);
    }
    
    let documentCollections = [];
    let componentName = "";
    if ($location.state.parts && $location.state.parts.length > 0) {
      documentCollections = $location.state.parts[0].document_collections;
      componentName = $location.state.parts[0].name;
    }
    else if (id && id !== "null" && $queryResults[id]) {
      const component = $queryResults[id]?.find(x => x.id === componentId);
      documentCollections = component.document_collections || [];
      componentName = component.name;
    } else {
      let query = {
        Type: "Lookup",
        LookupPartIDs: componentId.toString(),
        documentsOnly: true
      };
      const response = await testQuery(query);
      if (response.data.length > 0) {
        documentCollections = response.data[0].document_collections;
        componentName = response.data[0].name;
      }
    }

    document.title = `Docs ${componentName || ""}`;

    return { componentName, componentQuery, documentCollections };
  }
  
</script>

{#await loadDocs()}
  <Loading visible />
{:then data}
  <div class="container">
    <div class="component">
      {data.componentName || ""}
    </div> 
    {#each data.documentCollections as collection}
      <div class="collection">
        <span>{collection.name}</span>
        <Grid data={collection.documents} {columns} banded />
      </div>
    {/each}
  </div>
{:catch error}
  <Notification icon="error" message={error.message} visible />
{/await}

<style>
  .container {
    overflow-y: auto;
    width: 100%;
    height: 100vh;
  }
  
  .collection {
    margin-bottom: 10px;
  }

  .component {
    color: dimgray;
  }

  span {
    color: #175770;
  }
</style>